import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetAddressesQuery } from '../../apis/mlkApi/mlk.api.hooks';
import { Button } from '../../components/Button/Button';
import { EmptyState } from '../../components/EmptyState/EmptyState';
import { EmptyStateType } from '../../components/EmptyState/emptyStateHelper';
import { BaseLayout } from '../../components/Layout/Layout';
import { useLanguage } from '../../locale/useLanguage';
import { Address } from '../../models/address.models';
import { Routes } from '../../routes/types';

import './AddressesView.css';
import { AddressElement } from './components/AddressElement/AddressElement';

type AddressesViewProps = {};

export const AddressesView: React.FC<AddressesViewProps> = () => {
  const [t] = useLanguage();
  const history = useHistory();

  const { data } = useGetAddressesQuery(undefined);

  const addNew = useCallback(() => {
    history.push(Routes.CreateAddress);
  }, [history]);

  const goBack = useCallback(() => {
    history.push(Routes.Home);
  }, [history]);

  const isEmptyState = !data || (data && data.data && data.data.length === 0);

  return (
    <BaseLayout
      isGreyBg={isEmptyState}
      hasViewportHeight={isEmptyState}
      title={t('pageTitles.addresses')}
      hasBack
      onBackClick={goBack}
    >
      {isEmptyState && (
        <EmptyState
          type={EmptyStateType.Addresses}
          cta={
            <Button isPrimary label={t('addresses.addNew')} onClick={addNew} />
          }
        />
      )}
      {data && !isEmptyState && (
        <>
          {data.data.map((a: Address) => {
            return (
              <AddressElement
                key={a.id}
                addressId={a.id}
                addressFirstPart={`${a.route} ${a.number}`}
                addressName={a.name}
                addressType={a.addressType}
                addressSecondPart={`${a.zipCode} ${a.city}`}
              />
            );
          })}
          <div className="addresses-view--button-container">
            <Button isPrimary label={t('addresses.addNew')} onClick={addNew} />
          </div>
        </>
      )}
    </BaseLayout>
  );
};
